import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';
import { GeoArea } from '../../entities/control-tables/geo-area-entity';

 

export class GeoAreaRequest extends BaseRequest {

  geoArea : GeoArea

  constructor(userInfo : UserInfo){
    super(userInfo);
	this.geoArea = new GeoArea()
  }
}